import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver, useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { useTranslation } from '@/providers/app-provider/app-provider';

export type ReviewFormValues = {
  name: string;
  email: string;
  rating: string;
  title: string;
  message: string;
};

type UseReviewFormOptions = {
  requireGuestFields: boolean;
  defaultValues?: Partial<ReviewFormValues>;
};

const useReviewForm = ({ requireGuestFields, defaultValues }: UseReviewFormOptions) => {
  const { t } = useTranslation();

  const reviewSchema = object({
    name: requireGuestFields
      ? string().trim().required(t?.productDetail.addReviewModal.nameRequired)
      : string().default(''),
    email: requireGuestFields
      ? string()
          .trim()
          .required(t?.productDetail.addReviewModal.emailRequired)
          .email(t?.productDetail.addReviewModal.emailInvalid)
      : string().default(''),
    rating: string().required(),
    title: string().trim().required(t?.productDetail.addReviewModal.titleRequired),
    message: string().trim().required(t?.productDetail.addReviewModal.commentRequired),
  });

  return useForm<ReviewFormValues>({
    mode: 'onChange',
    defaultValues: {
      name: '',
      email: '',
      rating: '5',
      title: '',
      message: '',
      ...defaultValues,
    },
    resolver: yupResolver(reviewSchema) as Resolver<ReviewFormValues>,
  });
};

export default useReviewForm;
